var link_viewer_default = {
  "fontElementMap": "agav-",
  "link": "pDNga",
  "linkInEditor": "_8hsXd",
  "linkInViewer": "DSGma",
  "toolbarUrlContainer": "i-yoG",
  "toolbarUrl": "qX-c5",
  "toolbarUrlAnchor": "vxhDf"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
